import * as Yup from "yup";

export const getFormSchema = (t) => {
	return Yup.object().shape({
		transporeonEmail: Yup.string()
			.required(t("fill_required_fields"))
			.email(t("invalid_email_format")),
		transporeonCompany: Yup.string().required(t("fill_required_fields")),
	});
};
